import { Chip } from '@heroui/react';
import { ColumnDef } from '@tanstack/react-table';
import { MessageSquare } from 'lucide-react';
import React from 'react';
import { ClientRequestFirestoreResponse } from 'src/types';

import { getStatusMeta } from '../../constants';

export const ClientRequestsColumns: ColumnDef<ClientRequestFirestoreResponse>[] = [
  {
    header: 'Temat',
    accessorKey: 'subject',
    cell: ({ row }) => (
      <span className="font-medium text-gray-900">{row.original.subject || '—'}</span>
    ),
  },
  {
    header: 'Hotel',
    accessorKey: 'hotelName',
    cell: ({ row }) => row.original.hotelName || '—',
  },
  {
    header: 'Użytkownik',
    id: 'user',
    cell: ({ row }) => (
      <div className="flex flex-col">
        <span>{row.original.userName || '—'}</span>
        <span className="text-xs text-gray-400">{row.original.userEmail || ''}</span>
      </div>
    ),
  },
  {
    header: 'Kategoria',
    accessorKey: 'category',
    cell: ({ row }) => row.original.category || '—',
  },
  {
    header: 'Status',
    id: 'status',
    cell: ({ row }) => {
      const meta = getStatusMeta(row.original.status);
      return (
        <Chip size="sm" color={meta.color} variant="flat" radius="sm">
          {meta.label}
        </Chip>
      );
    },
  },
  {
    header: 'Odp.',
    id: 'replies',
    enableSorting: false,
    meta: { align: 'center' },
    cell: ({ row }) => {
      const count = row.original.replies?.length ?? 0;
      if (!count) return <span className="text-gray-300">—</span>;
      return (
        <span className="inline-flex items-center gap-1 text-gray-600">
          <MessageSquare size={14} />
          {count}
        </span>
      );
    },
  },
  {
    header: 'Utworzono',
    id: 'createdAt',
    cell: ({ row }) => {
      const ts = row.original.createdAt;
      if (ts?.toDate) return ts.toDate().toLocaleString('pl-PL');
      return row.original.timestamp || '';
    },
  },
];
